import React, { Component } from 'react'
import { CustomLabelData } from '../apis/customLabel.api'
import customLabelService from '../services/customLabel.service'
import Card from '../components/Card'
import DownloadLink from '../components/DownloadLink'
import List, { ListItem } from '../components/List'
import csvUtil from '../utils/csv.util'

interface Props {
  customLabel: CustomLabelData | null
}

export default class CustomLabelInfo extends Component<Props> {
  get list (): ListItem[] {
    const { customLabel } = this.props
    if (!customLabel) return []
    const { item, printed, remainingPrintablesCount } = customLabel
    const { hasPrintableLimit, printedCount, csvFilename, apiUrl } = customLabel
    const { csv, api } = printed
    const itemCode = item ? item.code : ''
    const csvPrints = customLabelService.printsText(csv.total, csv.printed)
    const apiPrints = customLabelService.printsText(api.total, api.printed)
    const downloadUrls = customLabelService.dataDownloadUrls(customLabel)
    const apiFilename = csvUtil.sanitizeFilename(apiUrl)
    return [
      {
        key: 'Item',
        value: itemCode
      },
      {
        key: 'CSV',
        value: downloadUrls.csv && csvFilename
          ? <DownloadLink path={downloadUrls.csv} text={csvFilename} />
          : null
      },
      {
        key: 'CSV prints',
        value: csvPrints
      },
      {
        key: 'API',
        value: downloadUrls.api
          ? <DownloadLink path={downloadUrls.api} text={apiFilename} />
          : null
      },
      {
        key: 'API prints',
        value: apiPrints
      },
      {
        key: 'Total printed',
        value: printedCount
      },
      {
        key: 'Remaining printables',
        value: hasPrintableLimit ? remainingPrintablesCount : 'unlimited'
      }
    ]
  }

  render () {
    return this.props.customLabel && (
      <Card>
        <List items={this.list} />
      </Card>
    )
  }
}
